type Upload = {
  id: string;
  created_at: string;
  updated_at: string;
  name: string;
  size: string;
  bucket_id: string;
};

// An Upload with an attached signed_url for fetching the file from the bucket
export type SignedUpload = Upload & {
  signed_url: string;
};

// DTO when creating an Upload
export type CreateUpload = {
  // The name of the uploaded file.
  // Might differ from the name of the file that the
  // user select, because we convert it to an image/jpeg.
  name: string;

  // The size of the uploaded file in bytes.
  size: number;

  // The name of the uploaded file in the bucket.
  // This is used when fetching the file after upload.
  bucket_id: string;
};

export type NewUpload = { type: "new"; createUpload: CreateUpload };
type ExistingUpload = { type: "existing"; uploadId: string };
export type NewOrExistingUpload = NewUpload | ExistingUpload;

export function isNewUpload(
  newOrExistingUpload: NewOrExistingUpload
): newOrExistingUpload is NewUpload {
  return newOrExistingUpload.type === "new";
}
